import { useGet } from "../useGet";
import { ChatMessagesApi } from "../../types";
import { jsonSerializer } from "../../utils";

export const useGetChatConversationMessages = () =>
  useGet({
    serializer: jsonSerializer((data: ChatMessagesApi) => data.messages),
  });
